import {
  Outlet,
  Link,
  useLoaderData,
  useParams,
  NavLink
} from "react-router-dom";

import { useState, useEffect } from "react";
import * as API from "../services/vispsicologicas";
import { FormatDate } from "../components/documentacion/FormatDate";

export async function loader({ params }) {
  const token = sessionStorage.getItem("token");

  // Si no hay token, simplemente NO llamamos a la API y retornamos null
  if (!token) {
    return null;
  }
  return API.getAllVispsicologicasByTax(params.tratamientoId);
}

export function VispsicologicasList(props) {
  const [vispsicologicasList, setVispsicologicas] = useState([]);
  let { tratamientoId } = useParams();

  useEffect(() => {
    API.getAllVispsicologicasByTax(props.id).then(setVispsicologicas).catch(console.log);
  }, [props.id]);
  return (
    <>
      {vispsicologicasList?.length ? (
          <ul className="vispsicologicas cpt-list">
            {vispsicologicasList
              .sort((a, b) => {
                // Convertir las fechas a objetos de fecha para comparar
                const dateA = new Date(`${a.meta.metaFecha}T${a.meta.vispsicHora}:00`);
                const dateB = new Date(`${b.meta.metaFecha}T${b.meta.vispsicHora}:00`);

                // Ordenar de manera descendente (más reciente primero)
                return dateB - dateA;
              })
              .map((vispsicologicas) => (
                <li key={vispsicologicas.id}>
                  <NavLink to={`${props.id}/hospitalizacion/visitas-psicologicas/${vispsicologicas.id}`}>{`${FormatDate(vispsicologicas?.meta?.metaFecha)}`}</NavLink>
                </li>
              ))}
            </ul>
          ) : (
            <></>
          )}
    </>
  );
}



export function VispsicologicasListContent(props) {
  let { tratamientoId } = useParams();
  console.log(tratamientoId);
  return (
    <>
      <div id="content">
        <h1>Visitas Psicológicas</h1>
      </div>
      <div id="actions">
      {(props.userRole.includes('administrador') || props.userRole.includes('psicologia-hospital') || props.userRole.includes("psicologia")) && (
        <Link className="button is-link" to={`new`}>Nuevo</Link>
      )}
      </div>
    </>
  );
}